import React, { useContext, useState } from 'react';
import { IoSettings } from "react-icons/io5";
import { toast } from "react-toastify";
import axios from "axios";
import GeneralContext from "../context/GeneralProvider";
import puma from '../assets/puma.png';
import {FaLongArrowAltRight} from "react-icons/fa";

function Name() {
    const { setVideo, setOrigin } = useContext(GeneralContext);
    const [name, setName] = useState('');
    const [emotion, setEmotion] = useState('sade');
    const [creating, setCreating] = useState(false);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const checkVideoExists = async (url, retries = 10, interval = 3000) => {
        for (let i = 0; i < retries; i++) {
            try {
                const res = await fetch(url, { method: 'HEAD' });
                if (res.ok) return true;
            } catch (err) {
                // isteği yut
            }
            await delay(interval);
        }
        return false;
    };

    const createVideo = async (e) => {
        e.preventDefault();
        setCreating(true);

        if (name.trim().length < 3) {
            toast.warning("İsim en az 3 harfli olmalı");
            setCreating(false);
            return;
        }

        try {
            const response = await axios.post("https://demo.clerkai.app/ai/api.php", {
                api_key: process.env.REACT_APP_API_KEY,
                name: name.trim(),
                emotion:emotion.trim()
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const videoUrl = response.data.video_url;

            const exists = await checkVideoExists(videoUrl);
            if (exists) {
                setVideo(videoUrl);
            } else {
                toast.error("Video oluşmadı veya geç cevap verdi." + videoUrl);
            }
        } catch (err) {
            console.error(err);
            toast.error("Sunucuyla iletişimde hata oluştu.");
        } finally {
            setCreating(false);
        }
    };

    const goOrigin = (e) => {
        e.preventDefault();
        setVideo("")
        setOrigin("puma");
    }

    return (
        <form onSubmit={createVideo}>
            <div style={{marginBottom: "5px"}}><img src={puma} style={{width: "300px"}}/></div>
            <div>
                <input
                    type="text"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder="Bir isim gir..."
                />
            </div>
            <div>
                <select onChange={e => setEmotion(e.target.value)} value={emotion}>
                    <option value="sade">Nasıl bir his?</option>
                    <option value="cool">Havalı</option>
                    <option value="rahat">Konforlu</option>
                    <option value="mutlu"> Mutlu</option>
                    <option value="dinamik">Dinamik</option>
                    <option value="heyecanli">Heyecanlı</option>
                </select>
            </div>
            <div>
            <button type="submit" disabled={creating}>
                    {creating ? <><IoSettings className="rotating"/> <span>Oluşturuluyor...</span></> : "Video oluştur"}
                </button>
            </div>
            <div><span onClick={goOrigin}>Orjinal reklam videosu <FaLongArrowAltRight/></span></div>
        </form>
    );
}

export default Name;
